import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SidebarLogo from './SidebarLogo';
import SidebarMenuItem from './SidebarMenuItem';
import { SidebarConfig } from '../../types/navigation.types';
import { useLocation } from 'react-router-dom';
import { RootState } from '../../store';
import { setSidebarCollapsed } from '../../store/slices/sidebarSlice';

interface SidebarProps {
  config: SidebarConfig;
  setShowSidebar: (show: boolean) => void;
}

const MobileSidebar: React.FC<SidebarProps> = ({ config, setShowSidebar }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isCollapsed = useSelector((state: RootState) => state.sidebar.isCollapsed);

  const handleMouseEnter = () => dispatch(setSidebarCollapsed(false));
  const handleMouseLeave = () => dispatch(setSidebarCollapsed(true));

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`${
        isCollapsed ? 'w-20' : 'w-64'
      } h-full min-h-[100vh] pb-[140px] bg-background w-full rounded-lg px-3 pt-2  flex-col transition-all duration-300 overflow-y-auto`}
    >
      <SidebarLogo
        logo={config.logo}
        isCollapsed={isCollapsed}
        setShowSidebar={setShowSidebar}
      />

      <hr className="my-2" />

      <nav className="flex flex-col gap-2">
        {config.menuItems.map((item) => (
          <SidebarMenuItem
            key={item.id}
            item={item}
            isActive={location.pathname === item.path}
            isCollapsed={isCollapsed}
          />
        ))}
      </nav>
    </div>
  );
};

export default MobileSidebar;
